// extracted by mini-css-extract-plugin
export default {"joinField":"styles_joinField__O1Uid","label":"styles_label__5u-7l","inputWrapper":"styles_inputWrapper__gCoQK","warningArea":"styles_warningArea__ZCKBY"};